


















import { Component, Vue, Prop } from "vue-property-decorator";
import { GListOption } from "shared/global/types";

@Component
export default class List extends Vue {
  @Prop({ required: true, type: Array }) public value!: GListOption[];
  @Prop({ default: "", type: String }) public subHeader!: string;

  get hasSubheader(): boolean {
    return this.subHeader !== "";
  }
}
